import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class ApiEmptyResponseInterceptor implements HttpInterceptor {

  constructor(private messageService: MessageService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (event.status == 204 || (event.status == 200 && event.body == null)) {
          let serviceName: any = '';
          if (event.url) {
            serviceName = event.url.split('/').pop();
            serviceName = serviceName.match(/[A-Z][a-z]+/g);
            if (serviceName) {
              serviceName = serviceName.map((word:any) => { return word.toLowerCase() }).join(" ");
            }
          }
          if(serviceName=='info ID'){
            this.messageService.add({ key: 'emptyToster', severity: 'warn', life: 5000, summary: 'Info Message', detail: 'Our team is working on projecting the routing on the map.  Please try again at a later time.' });
          }
        }
      }
    }));
  }
}
